import React from "react";
import { ArrowRight, ShieldCheck, Clock, Wrench } from "lucide-react";
import { businessInfo, heroImage } from "../mock";

const Hero = () => {
  return (
    <section id="top" className="relative pt-28 pb-20 lg:pt-36 lg:pb-28 overflow-hidden">
      <div className="absolute inset-0 circuit-pattern opacity-30 pointer-events-none" />
      <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-[420px] h-[420px] rounded-full bg-red-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="reveal">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 text-emerald-300 text-xs font-medium">
            <span className="relative inline-flex w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
            Ανοιχτά τώρα — Δωρεάν Διάγνωση
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-white">
            Επισκευάζουμε
            <br />
            ό,τι άλλοι <span className="text-emerald-400 text-glow-green">δεν μπορούν</span>.
          </h1>
          <p className="mt-5 text-lg text-emerald-50/70 max-w-xl">
            {businessInfo.description}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#contact"
              data-cta="request_quote"
              className="btn-primary rounded-md px-6 py-3 inline-flex items-center justify-center gap-2"
            >
              Ζητήστε προσφορά <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="#services"
              className="btn-outline rounded-md px-6 py-3 inline-flex items-center justify-center"
            >
              Δείτε υπηρεσίες
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-3 max-w-lg">
            {[
              { icon: Clock, t: "24h", s: "Εκτίμηση" },
              { icon: ShieldCheck, t: "6μήνες", s: "Εγγύηση" },
              { icon: Wrench, t: "15K+", s: "Επισκευές" },
            ].map((it, i) => (
              <div
                key={i}
                className="pcb-card px-3 py-3 text-center"
              >
                <it.icon className="w-5 h-5 text-emerald-400 mx-auto" />
                <div className="mt-1 text-white font-bold">{it.t}</div>
                <div className="text-xs text-emerald-100/60">{it.s}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="reveal relative">
          <div className="relative rounded-2xl overflow-hidden border border-emerald-500/30 glow-green">
            <img
              src={heroImage}
              alt="Τεχνικός της Repairzone επισκευάζει μητρική πλακέτα laptop στη Λαμία"
              width="1200"
              height="800"
              fetchpriority="high"
              decoding="async"
              className="w-full h-[480px] object-cover img-hover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#04101c] via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-end">
              <div className="px-3 py-1.5 rounded-md bg-black/60 border border-emerald-500/40 text-emerald-300 text-xs font-mono">
                STATUS • RECOVERED
              </div>
            </div>
          </div>

          <div className="absolute -bottom-6 -left-6 pcb-card p-4 hidden md:block">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-md bg-red-500/15 border border-red-500/40 flex items-center justify-center">
                <Wrench className="w-5 h-5 text-red-400" />
              </div>
              <div>
                <div className="text-white font-semibold text-sm">
                  Επαγγελματικός εξοπλισμός
                </div>
                <div className="text-xs text-emerald-100/60">
                  Γνήσια ανταλλακτικά • Εγγύηση
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
